import gql from 'graphql-tag';

export const ADVISER_ENROLMENT_COMPANIES_QUERY = gql`
  query adviserEnrolmentCompanies {
    adviserEnrolmentCompanies {
      id
      tradingName
    }
  }
`;

export const ASSIGN_ADVISOR_MUTATION = gql`
  mutation assignAdvisor(
    $testatorId: ID!
    $email: String!
    $sendEmail: Boolean
  ) {
    assignAdvisor(
      testatorId: $testatorId
      email: $email
      sendEmail: $sendEmail
    ) {
      id
      fullName
      email
      company {
        id
        tradingName
        executorship
        negotiableExecutorFee
        defaultExecutorFeePercentage
      }
    }
  }
`;

export const REMOVE_ADVISOR_MUTATION = gql`
  mutation removeAdvisor($testatorId: ID!, $sendEmailToAdvisor: Boolean) {
    removeAdvisor(
      testatorId: $testatorId
      sendEmailToAdvisor: $sendEmailToAdvisor
    ) {
      testator {
        id
        advisorId
        advisor {
          id
          fullName
        }
      }
    }
  }
`;

export const ADVISOR_MANAGED_TESTATORS_QUERY = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      managedTestators {
        id
        user {
          id
          fullName
          email
        }
      }
    }
  }
`;

export const ADVISOR_REQUEST_MUTATION = gql`
  mutation advisorRequest(
    $firstName: String!
    $lastName: String!
    $emailAddress: String!
    $cellNumber: String!
    $staffCode: String!
  ) {
    advisorRequest(
      firstName: $firstName
      lastName: $lastName
      emailAddress: $emailAddress
      cellNumber: $cellNumber
      staffCode: $staffCode
    ) {
      success
    }
  }
`;

export const ADVISER_COMMUNICATIONS_QUERY = gql`
  query adviserCommunications {
    adviserCommunications {
      id
      date
      title
      previewText
      url
      read
    }
  }
`;

export const ADVISER_COMMUNICATIONS_UNREAD_COUNT_QUERY = gql`
  query adviserCommunicationsUnreadCount {
    adviserCommunicationsUnreadCount
  }
`;

export const HAS_ADVISER_COMMUNICATIONS_QUERY = gql`
  query hasAdviserCommunications {
    hasAdviserCommunications
  }
`;

export const MARK_ADVISER_COMMUNICATION_READ_MUTATION = gql`
  mutation markAdviserCommunicationRead($adviserCommunicationId: ID!) {
    markAdviserCommunicationRead(
      adviserCommunicationId: $adviserCommunicationId
    ) {
      adviserCommunication {
        id
        read
      }
    }
  }
`;

export const REGISTER_ADVISER_MUTATION = gql`
  mutation registerAdviser(
    $firstNames: String!
    $lastName: String!
    $email: String!
    $adviserCode: String!
    $companyId: ID!
    $password: String!
  ) {
    registerAdviser(
      firstNames: $firstNames
      lastName: $lastName
      email: $email
      adviserCode: $adviserCode
      companyId: $companyId
      password: $password
    ) {
      testatorId
      accessToken
      refreshToken
      userId
      belongsToCompany
      email
      phone
      uniqueIdentifier
      fullName
      advisorName
      advisorEmail
      companyName
      companyId
      companyLogoUrl
      willCountry
    }
  }
`;
